import { render, staticRenderFns } from "./onlinehealthmanagement.vue?vue&type=template&id=3207be63&scoped=true&"
import script from "./onlinehealthmanagement.vue?vue&type=script&lang=js&"
export * from "./onlinehealthmanagement.vue?vue&type=script&lang=js&"
import style0 from "./onlinehealthmanagement.vue?vue&type=style&index=0&id=3207be63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3207be63",
  null
  
)

export default component.exports